import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';

import ImageEmptyTable from '../../../assets/images/empty-table-placeholder.svg';

import { TableEmptyStateWrapper } from './TableEmptyStateWrapper';

interface ITableFilteredEmptyPlaceholderProps {
  itemType: string;
  subtitle?: string;
  onClearFilters?: () => void;
}

export const TableFilteredEmptyPlaceholder = ({
  itemType,
  subtitle = "There's nothing here right now. Try adjusting your filters or click",
  onClearFilters,
}: ITableFilteredEmptyPlaceholderProps) => {
  const theme = useTheme();

  return (
    <TableEmptyStateWrapper>
      <img src={ImageEmptyTable} alt={`No ${itemType} found`} />
      <Box sx={{ width: '100%' }}>
        <Typography variant="h5" sx={{ mb: 1.5 }}>
          No {itemType} to show
        </Typography>
        <Typography>
          {subtitle}
          <Typography component="span" display="inline" fontWeight={theme.typography.fontWeightMedium}>
            {' '}
            Clear Filters{' '}
          </Typography>
          to view all {itemType}.
        </Typography>
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Button variant="outlined" onClick={onClearFilters} sx={{ mt: 3, mr: 'auto', ml: 'auto' }}>
            Clear Filters
          </Button>
        </Box>
      </Box>
    </TableEmptyStateWrapper>
  );
};
